import './SdoRequestStatus.scss'
import { requestStatusType } from '../../pages/SdoAdmin/sdoAdminHelper';


export default function SdoRequestStatus({status, remarks}) {
    
    const getStatusColorClassName = (status: string) => {
        switch(status) {
            case requestStatusType.APPROVED:
                return 'status-display--approved';
    
            case requestStatusType.DECLINED:
                return 'status-display--declined';

            case requestStatusType.EXCEPTION:
                return 'status-display--exception';
    
            case requestStatusType.REVOKED:
                return 'status-display--revoked';
    
            case requestStatusType.SUBMITTED:
                return 'status-display--submitted'; 
            
            case requestStatusType.CONFLICT:
                return 'status-display--conflict'; 
        }
    }

    return (
        <div className='table__cell--status__cntr'>
            <p className={`status-display ${getStatusColorClassName (status.toString() ?? '')}`}>{status}</p>
            <p className='status-remarks'>{status === requestStatusType.CONFLICT ? '' :remarks}</p>
        </div>
    )
}
